import React from "react";
import Hero from "./Hero";
import AppelAction from "../../components/AppelAction";


const Actualites = () => {
    return (
        <>
            <Hero />
            <AppelAction className="section-border-top" />
        </>
    );
};

export default Actualites;
